module.exports = __webpack_public_path__ + "img/RH.09c57ff8.svg";